var unreadScroller = window.unreadScroller = {
    all: null,
    active: null,
    init: function(){
        this.initArrows();
        this.all = $('.com.unread');
        this.scrollTracking();
    },

    scrollTracking: function(){
        var hash = window.location.hash;
        console.log(hash);
        if(hash == '#new-comments') {
            var found = this.next();
            if(found !== false){
                history.replaceState(null, null, ' ');
            }
        }
    },

    initArrows: function(){
        $(document).keydown(function(e) {
            if(e.which == 37 || e.which == 39){
                var active = $(document.activeElement);
                if(active.is('input') || active.is('textarea')){
                    return
                }
                if(e.which == 37){
                    unreadScroller.prev();
                }
                if(e.which == 39){
                    unreadScroller.next();
                }
            }
        });
    },

    next: function(){
        console.log('NEXT COM CALL');
        if(this.active === null) {
            var next = this.findNext();
            if(next !== null){
                this.mark(next);
                this.initBodyClick();
            } else {
                return false;
            }

        } else {
            this.mark(this.active + 1);
        }
    },

    prev: function(){
        if(this.active === null) {
            var prev = this.findPrev();
            if(prev !== null){
                this.mark(prev);
                this.initBodyClick();
            }
        } else {
            this.mark(this.active - 1);
        }
    },

    initBodyClick: function(){
        $('body').one('dblclick', function(){
            this.all.eq(this.active).removeClass('selected');
            this.active = null;
        }.bind(this));
    },



    mark(index){
        var newActive = this.all.eq(index);
        if(index >= 0 && newActive.length) {
            this.all.eq(this.active).removeClass('selected');
            this.active = index;

            var newActive = newActive.addClass('selected');
            newActive[0].scrollIntoView({block: 'center',behavior: "smooth"});
        }
    },

    findPrev(){
        var wh = $(window).height();

        for(var i = this.all.length -1; i >= 0; i--){

            var pos = this.all.eq(i)[0].getBoundingClientRect();
            var fromBottom = wh - pos.bottom;
            if(fromBottom >= wh / 2){
                return i;
            }
        }
        return null;
    },

    findNext(){
        var wh = $(window).height();

        for(var i = 0; i < this.all.length; i++){

            var pos = this.all.eq(i)[0].getBoundingClientRect();
            var fromBottom = wh - pos.bottom;
            if(fromBottom <= wh / 2){
                return i;
            }
        }
        return null;
    }

}


// WEBPACK FOOTER //
// ./Resources/assets/js/comments-scroller.js